import { render, staticRenderFns } from "./MobileEventShare.vue?vue&type=template&id=172973d4&scoped=true"
import script from "./MobileEventShare.vue?vue&type=script&lang=ts"
export * from "./MobileEventShare.vue?vue&type=script&lang=ts"
import style0 from "./MobileEventShare.vue?vue&type=style&index=0&id=172973d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172973d4",
  null
  
)

export default component.exports